import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"shop_order",
    list_id:"shop_order_list",
    x_column_list_arr:[
      {"key":"a_title","name":"주문","width":"250","is_show":"1"},
      {"key":"a_date","name":"요청일","width":"100","is_show":"1"},
      {"key":"mcomp_name","name":"요청학원","width":"120","is_show":"1"},
      {"key":"a_user_name","name":"요청자","width":"80","is_show":"1"},
      // {"key":"row_view_in_out","name":"구분","width":"70","is_show":"1"},
      {"key":"row_view_state","name":"상태","width":"100","is_show":"1"},
      {"key":"row_view_payt_sort","name":"결제구분","width":"100","is_show":"1"},
      // {"key":"row_view_payt_btn","name":"관리","width":"100","is_show":"1"},
      // {"key":"order_det_amount","name":"수량","width":"100","is_show":"1"},
      // {"key":"order_det_price","name":"가격","width":"100","is_show":"1"},
      // {"key":"row_view_detail_title","name":"주문상세","width":"520","is_show":"1"},
      {"key":"det_sort","name":"구분","width":"100","is_show":"1"},
      {"key":"det_product_name","name":"상품","width":"180","is_show":"1"},
      {"key":"det_buyer_name","name":"구매자","width":"100","is_show":"1"},
      {"key":"det_amount","name":"수량","width":"80","is_show":"1"},
      {"key":"det_money","name":"가격","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':30,
      'order_id':'',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;